/*
 * The admin site's words in English: the shell - the sidebar and the Overview
 * page (S48, extended to the admin site 2026-10-29).
 */

export const shellEn = {
  /** The admin sidebar's links (AdminLayout.tsx). */
  sidebar: {
    label: 'Admin sections',
    overview: 'Overview',
    articles: 'Articles',
    releaseNotes: 'Release notes',
    attachments: 'Attachments',
    promoted: 'Promoted',
    questions: 'Questions',
    metadata: 'Metadata',
    settings: 'Settings',
  },

  /** The Overview page (DashboardPage.tsx). */
  overview: {
    loading: 'Loading the overview…',
    title: 'Overview',
    intro: 'The state of the knowledge base right now.',
    newArticle: 'New article',
    articles: 'Articles',
    live: 'Live',
    scheduled: 'Scheduled',
    hidden: 'Hidden',
    needsAttention: 'Needs attention',
    unpublishedDrafts: 'Unpublished drafts',
    unpublishedDraftsHint: 'A newer revision exists than the one readers get.',
    withdrawn: 'Text withdrawn',
    withdrawnHint:
      'Revisions exist but none is current: the published text was taken back, and nothing is served until one is promoted.',
    unwritten: 'Not written yet',
    unwrittenHint: 'The article exists with no revision at all, so there is nothing to show.',
    untagged: 'Untagged articles',
    untaggedHint:
      'Missing a category tag. The product is a column on the article, so that half is never missing.',
    recentlyEdited: 'Recently edited',
    nothingEdited: 'Nothing has been edited yet.',
    nextScheduled: 'Next scheduled',
    /** {date} is the publish date and time. */
    goesLive: 'Goes live {date}',
    nothingScheduled: 'Nothing is scheduled.',
    metadata: 'Metadata',
    tagCounts: (products: number, categories: number) =>
      `${products} product tag${products === 1 ? '' : 's'} · ${categories} category tag${categories === 1 ? '' : 's'}`,
    manageMetadata: 'Manage metadata',
  },
};
